export const header_intro = {
  heading1: "Hi, ",
  heading2: "I'm Tedane.",
  subheading: "A Full-Stack Web Developer.",
};
